
import { jsPDF } from "jspdf";
// import { numberFormat, toNumber } from "utils";
// import { toBahtText } from "utils/toBahtText";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import dayjs from "dayjs";
// import companyLogo from "branch/resource/company-logo.png"
import { branchNoText } from "utils/branchNoText";
import { printHeader } from "branch/functions/pirntHeader";
import { printTable } from "utils/printTable";
import { printBankAccount, printBNColumns } from "./columns";
import { addSumRow } from "utils/highlightSumColor";

export const printBillingNote365 = ({ bnData, companyData }) => {

  const pageSize = [8.3, 11.7]; //A4
  // const defaultHeaderSize = 20;
  // const comapanyAddrSize = 10;
  const contentSize = 12;
  // const totalSize = 15

  // const pl = 0.1
  const startY = 0.4
  const startX = 0.5
  // const logoWidth = 0.85
  // const logoHeight = 0.85
  const lineHeight = 0.2
  const addrBoxW = 5
  const addrBoxH = 1.1
  const dateBoxW = 2
  const dateBoxH = 0.5

  const addrDateGap = 3.5
  const dateStartX = startX + addrBoxW + addrDateGap
  const dataBoxW = addrBoxW + addrDateGap + dateBoxW

  const doc = new jsPDF({
    orientation: "lanscape",
    unit: "in",
    format: pageSize
  });
  // const MAX_PAGE_SIZE = 25

  const totalPage = 1
  // let rowStart = 0
  let pageNo = 1
  // let maxRow = MAX_PAGE_SIZE

  do {
    if (pageNo !== 1) {
      doc.addPage(pageSize, "lanscape")
    }

    let yPos = startY
    let xPos = startX
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(22)
    doc.text("ใบวางบิล\n(Billing Note)", 10, 0.83, { align: "center" })

    if (totalPage > 1) {
      doc.setFontSize(17)
      doc.text(`หน้า (${pageNo}/${totalPage})`, startX + dataBoxW, 1.55, { align: "right" })
    }
    yPos = printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos })

    yPos += lineHeight
    let yDatePos = yPos
    doc.setLineWidth(0.01)
    doc.lines([[addrBoxW, 0], [0, addrBoxH], [addrBoxW * -1, 0], [0, addrBoxH * -1]], startX, yPos, [1, 1], 'S', true)
    yPos += lineHeight
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    const addrStartx = startX + 0.2
    const addrDatax = addrStartx + 0.4
    doc.text("ลูกค้า", addrStartx, yPos)
    doc.text(bnData.BillNm, addrDatax, yPos)
    yPos += lineHeight
    doc.text("ที่อยู่", addrStartx, yPos)

    const addrs = doc.splitTextToSize(bnData.BillAddr, 4.4)
    doc.text(addrs.join("\n"), addrDatax, yPos)
    // doc.text(bnData.BillAddr, addrDatax, yPos)
    yPos += lineHeight + lineHeight + lineHeight
    doc.text("เลขประจำตัวผู้เสียภาษี", addrStartx, yPos)
    doc.text(`${bnData.BillTaxId} ${branchNoText(bnData.BillNm, bnData.BillBrchNo)}`, addrDatax + 0.8, yPos)
    yPos += lineHeight * 2

    //--------------------------------------- Box Date -----------------------------------------------------------
    doc.setFillColor("#cce6ff")
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'DF', true)
    doc.text("Date", dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })
    yDatePos += dateBoxH / 2
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'S', true)
    doc.text(dayjs(bnData.BNDte).format("DD/MM/YYYY"), dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })

    yDatePos += dateBoxH / 2 + 0.1
    doc.setFillColor("#cce6ff")
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'DF', true)
    doc.text("Billing Note No.", dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })
    yDatePos += dateBoxH / 2
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'S', true)
    doc.text(bnData.BNNo, dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })

    const dataTable = bnData.Invs.map((item, index) => ({
      ...item,
      No: index + 1,
      id: item.InvId,
      PayAmnt: +item.GrandTotal - +item.WhtPr1Total - +item.WhtPr3Total,
    }))
    const finalTable = addSumRow({
      dataTable,
      sumColNms: ["GrandTotal", "WhtPr1Total", "WhtPr3Total", "PayAmnt"],
      sumColTotal: "ContNo"
    })
    yPos = printTable({
      doc,
      dataTable: finalTable,
      columns: printBNColumns,
      startX: startX,
      startY: yPos,
      fontSize: 12
    })

    let total365 = 0
    let wht365 = 0
    for(const data of bnData.Exps){
      if(data.WhtPr){
        wht365 += +data.WhtPr
      }
      total365 += +data.Total
    }
    let totalLIT = 0 
    let whtLIT = 0
    for(const data of bnData.ExpsLIT){
      if(data.WhtPr){
        whtLIT += +data.WhtPr
      }
      totalLIT += +data.Total
    }
    yPos += lineHeight*2
    doc.setFont("THSarabun", "bold")
    doc.text("Payment Summary", startX, yPos)
    doc.setFont("THSarabun", "normal")
    const AccTable = []
    if(totalLIT > 0){
      AccTable.push({
        AccNm: "LAEMCHABANG INTER TRANS",
        AccNo: "653-3-01211-6",
        Bank: "SCB Bank",
        Amnt: totalLIT - whtLIT
      })
    }
    if(total365 > 0){
      AccTable.push({
        AccNm: "365 WORLDWIDE",
        AccNo: "653-4-356244-6",
        Bank: "SCB Bank",
        Amnt: total365 - wht365
      })
    }
    yPos = printTable({
      doc, 
      dataTable: AccTable,
      columns: printBankAccount, 
      startX: startX,
      startY: yPos,
    })
    yPos -= lineHeight/2
    const accTableWidth = printBankAccount.reduce((acc, col) => acc + (col.printWidth || 0.5), 0)
    doc.line(startX, yPos, startX + accTableWidth, yPos )

    // for (const data of bnData.Exps) {
    //   if (data.WhtPr > 0) {
    //     if (data.WhtPrct === 1) {
    //       wht1 += +data.WhtPr
    //     } else if (data.WhtPrct === 3) {
    //       wht3 += +data.WhtPr
    //     } else {
    //       whtOth += +data.WhtPr
    //     }
    //     const found = whtData.find(item => item.ExpId === data.ExpId && item.WhtPrct === data.WhtPrct)
    //     if (found) {
    //       found.WhtPrTotal += +data.WhtPr
    //     } else {
    //       whtData.push({
    //         ExpId: data.ExpId,
    //         ExpNm: data.ExpNm,
    //         WhtPrct: data.WhtPrct,
    //         WhtPrTotal: +data.WhtPr
    //       })
    //     }
    //   }
    // }
    // for (const data of bnData.ExpsLIT) {
    //   if (data.WhtPr > 0) {
    //     if (data.WhtPrct === 1) {
    //       wht1 += +data.WhtPr
    //     } else if (data.WhtPrct === 3) {
    //       wht3 += +data.WhtPr
    //     } else {
    //       whtOth += +data.WhtPr
    //     }
    //     const found = whtData.find(item => item.ExpId === data.ExpId && item.WhtPrct === data.WhtPrct)
    //     if (found) {
    //       found.WhtPrTotal += +data.WhtPr
    //     } else {
    //       whtDataLIT.push({
    //         ExpId: data.ExpId,
    //         ExpNm: data.ExpNm,
    //         WhtPrct: data.WhtPrct,
    //         WhtPrTotal: +data.WhtPr
    //       })
    //     }
    //   }
    // }
    pageNo++
    // maxRow = pageNo * MAX_PAGE_SIZE
    // rowStart = maxRow - MAX_PAGE_SIZE
  } while (pageNo <= totalPage)

  doc.output('dataurlnewwindow');
}